
import { LucideIcon } from 'lucide-react'

interface SegmentedControlOption {
  id: string
  label: string
  icon?: LucideIcon
  count?: number
  color?: string
}

interface SegmentedControlProps {
  options: SegmentedControlOption[]
  activeOption: string
  onChange: (optionId: string) => void
  className?: string
}

export function SegmentedControl({ options, activeOption, onChange, className = '' }: SegmentedControlProps) {
  return (
    <div className={`flex flex-col sm:flex-row space-y-1 sm:space-y-0 sm:space-x-1 bg-border-light rounded-xl p-1 shadow-sm ${className}`}>
      {options.map((option) => {
        const IconComponent = option.icon
        const isActive = activeOption === option.id
        
        return (
          <button
            key={option.id}
            onClick={() => onChange(option.id)}
            className={`flex-1 flex items-center justify-center space-x-2 px-2 sm:px-3 py-2 rounded-lg text-xs sm:text-sm font-medium transition-all min-w-0 ${
              isActive
                ? 'bg-background-white text-text-primary'
                : 'text-text-secondary hover:text-text-primary hover:bg-background-white/50'
            }`}
          >
            {IconComponent && <IconComponent className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0" />}
            <span className="truncate">{option.label}</span>
            {typeof option.count !== 'undefined' && option.count > 0 && (
              <span className={`px-1.5 sm:px-2 py-0.5 rounded-full text-xs flex-shrink-0 ${
                isActive && option.color ? option.color : 'bg-text-secondary/10 text-text-secondary'
              }`}>
                {option.count}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}